import { listResource } from './list-resource'
import { singletonResource } from './singleton-resource'
import { oneResource } from './one-resource'

export const resource = resource => ({
  ...listResource(resource),
  ...singletonResource(resource),
  ...oneResource(resource)
})
